import React, { useContext, useEffect } from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import waveBg from 'assets/img/illustrations/bg-wave.png';
import AppContext /* { CourseContext } */ from 'context/Context';
import ProjectBanner from './ProjectBanner';
import ProjectPricing from './ProjectPricing';
import ProjectFeatures from './ProjectFeatures';
import ProjectQualities from './ProjectQualities';
import ProjectGallery from './ProjectGallery';
import ProjectProponent from './ProjectProponent';
//import ProjectReviews from './ProjectReviews';
//import SimilarProjects from './SimilarProjects';
import ProjectTerrains from './ProjectTerrains ';
import { useParams } from 'react-router-dom';

//import { courseData } from 'data/elearning/courseData';
import useProject from '../useProject';

const ProjectDetails = () => {
 const { configDispatch } = useContext(AppContext);

 const { id, user } = useParams();
 const { dataProject } = useProject({ id });

 useEffect(() => {
  configDispatch({
   type: 'RESTORE',
   payload: { tem: true, isFluid: true, navbarPosition: 'top', disabledNavbarPosition: ['vertical', 'combo'] }
  });
 }, []);

 return (
  dataProject && (
   <>
    <ProjectBanner data={dataProject} />
    <Row className="g-lg-3">
     <Col lg={8} className="order-1 order-lg-0">
      <ProjectFeatures />
      <ProjectQualities data={dataProject.qualities} />
      <ProjectTerrains terrains={dataProject.terrains} project={dataProject._id} />
      <ProjectGallery images={dataProject.images} />
      <ProjectProponent company={dataProject.company} user={user} />
      {/* <ProjectReviews data={courseReviews} /> */}
      {/*  <SimilarProjects /> */}
     </Col>
     <Col lg={4}>
      <div className="course-details-sticky-sidebar mb-lg-8 mt-xl-n10 pe-xl-4 pe-xxl-7">
       <ProjectPricing data={dataProject} />
       <div className="d-none d-xl-block position-absolute z-index--1 top-0 end-0 text-end me-n2 me-xxl-4 mt-xl-6">
        <Image src={waveBg} alt="" style={{ maxWidth: '23.75rem' }} className="bg-card" />
       </div>
      </div>
     </Col>
    </Row>
   </>
  )
 ); /* : (
  <Navigate to={`/project/details/1`} />
 ); */
};

export default ProjectDetails;
